import { render, staticRenderFns } from "./page7.vue?vue&type=template&id=71b5ca4b&scoped=true&"
import script from "./page7.vue?vue&type=script&lang=js&"
export * from "./page7.vue?vue&type=script&lang=js&"
import style0 from "./page7.vue?vue&type=style&index=0&id=71b5ca4b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b5ca4b",
  null
  
)

export default component.exports